import React from "react";
import { Link } from "react-router-dom";
import LanguageSwitcher from "../LanguageSwitcher";

const DESKTOP_BG_IMAGE =
  "https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&w=2000&q=80";

export default function AuthShell({
  title,
  subtitle,
  children,
  helperLinks,
  tagline = "Orrith",
  mission = "Cycle of Certainty",
}) {
  return (
    <div className="min-h-screen bg-white dark:bg-neutral-950 text-gray-900 dark:text-gray-100 relative transition-colors">
      <div className="lg:hidden border-b border-gray-200 dark:border-neutral-800 px-4 py-4 flex items-center justify-between bg-white dark:bg-neutral-950">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-green-600 dark:text-green-400">{tagline}</p>
          <h1 className="text-lg font-semibold leading-tight text-gray-900 dark:text-white">{title}</h1>
        </div>
        <LanguageSwitcher variant="dropdown" />
      </div>

      <div
        className="hidden lg:block absolute inset-0"
        aria-hidden="true"
        style={{
          backgroundImage: `linear-gradient(120deg, rgba(3, 7, 18, 0.68), rgba(6, 78, 59, 0.4)), url(${DESKTOP_BG_IMAGE})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <div className="hidden lg:block absolute inset-0 bg-gradient-to-t from-black/45 via-black/15 to-black/35" aria-hidden="true" />

      <div className="hidden lg:flex absolute top-6 left-8 z-20 text-white items-center gap-3">
        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-emerald-200/95">{mission}</p>
          <p className="text-lg font-semibold">{tagline}</p>
        </div>
      </div>

      <div className="hidden lg:flex absolute top-6 right-8 z-20">
        <LanguageSwitcher variant="dropdown" />
      </div>

      <div className="min-h-screen relative z-10 px-4 py-8 sm:px-6 sm:py-10 lg:px-8 lg:py-12 flex items-center justify-center">
        <main className="w-full max-w-lg">
          <section className="rounded-3xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 shadow-[0_24px_70px_rgba(0,0,0,0.24)] dark:shadow-[0_24px_70px_rgba(0,0,0,0.45)] ring-1 ring-black/5 dark:ring-white/10 p-6 sm:p-8 transition-colors">
            <header className="mb-6">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-green-600 dark:text-green-400">{tagline}</p>
              <h1 className="text-2xl sm:text-3xl font-bold mt-1 text-gray-900 dark:text-white">{title}</h1>
              {subtitle ? <p className="text-sm text-gray-600 dark:text-gray-300 mt-2">{subtitle}</p> : null}
            </header>

            {children}

            {Array.isArray(helperLinks) && helperLinks.length > 0 && (
              <div className="mt-7 pt-5 border-t border-gray-200 dark:border-neutral-800 text-sm text-gray-600 dark:text-gray-300 flex flex-wrap justify-center text-center gap-x-4 gap-y-2">
                {helperLinks.map((link) => (
                  <Link key={link.to} to={link.to} className="text-green-700 dark:text-green-400 hover:text-green-800 dark:hover:text-green-300 font-medium">
                    {link.label}
                  </Link>
                ))}
              </div>
            )}
          </section>
        </main>
      </div>
    </div>
  );
}
